"use client";

import React from "react";
import { Card } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  title: "MENU",
  description: "From smash burgers to karahi, experience the boldest Punjabi-American fusion in Irving.",
  icon: "/img/sultani_burger_icon.png"
}, {
  title: "CATERING",
  description: "Feed your next event right with our certified halal platters and signature spice blends.",
  icon: "/img/sultani_catering_tray.png"
}, {
  title: "EVENTS",
  description: "See what's happening at the grill, from live screenings to community fusion nights.",
  icon: "/img/sultani_events_calendar.png"
}];
export default function EngineeredForExcellence() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}